import addDays from "date-fns/addDays";
import moment from "moment";
import { getAuthData } from "../../services/AuthService";


export interface iPurchaseOrderFilter {
    PoNo: string;
    CustomerPoNo: string;
    CustomerID: number;
    ManufacturerID: number;
    EndUserID: number;
    From: string;
    To: string;
    StaffID: number;
    Region: string;
    IsAPGen: boolean;
    IsPaid: boolean;
    IsSample: boolean;
    IsOutstanding: boolean;
    IsSpecialDiscount: boolean;
    readonly Reader: string;
}

export class PurchaseOrderFilter {
    PoNo: string;
    CustomerPoNo: string;
    CustomerID: number;
    ManufacturerID: number;
    EndUserID: number;
    From: string;
    To: string;
    StaffID: number;
    Region: string;
    IsAPGen: boolean;
    IsPaid: boolean;
    IsSample: boolean;
    IsOutstanding: boolean;
    IsSpecialDiscount: boolean;
    readonly Reader: string;

    constructor();
    constructor(obj: iPurchaseOrderFilter);	
    constructor(obj?: iPurchaseOrderFilter) { 
        this.PoNo = obj?.PoNo ?? "";
        this.CustomerPoNo = obj?.CustomerPoNo ?? "ALL";
        this.CustomerID = obj?.CustomerID ?? 0;
        this.ManufacturerID = obj?.ManufacturerID ?? 0;
        this.EndUserID = obj?.EndUserID ?? 0;
        this.From = moment(obj?.From ?? addDays(new Date(), -7)).format();
        this.To = moment(obj?.To ?? new Date()).format();
        this.StaffID = obj?.StaffID ?? 0;
        this.Region = obj?.Region ?? "ALL";
        this.IsAPGen = obj?.IsAPGen ?? false;
        this.IsPaid = obj?.IsPaid ?? false;
        this.IsSample = obj?.IsSample ?? false;
        this.IsOutstanding = obj?.IsOutstanding ?? false;
        this.IsSpecialDiscount = obj?.IsSpecialDiscount ?? false;
        this.Reader = getAuthData()?.userName ?? "";    
    }
}

export interface iPurchaseOrderHistoryFilter {
    SearchString: string;
    CustomerID: number;
    EndUserID: number;
    readonly Reader: string;
}

export class PurchaseOrderHistoryFilter {
    SearchString: string;
    CustomerID: number;
    EndUserID: number;
    readonly Reader: string;

    constructor();
    constructor(obj: iPurchaseOrderHistoryFilter);	
    constructor(obj?: iPurchaseOrderHistoryFilter) { 
        this.SearchString = obj?.SearchString ?? "";
        this.CustomerID = obj?.CustomerID ?? 0;
        this.EndUserID = obj?.EndUserID ?? 0;
        this.Reader = getAuthData()?.userName ?? "";    
    }
}

export interface iPurchaseOrderRankFilter {
    From: string;
    To: string;
    Region: string;
    Type: number;
    readonly Reader: string;
}

export class PurchaseOrderRankFilter {
    From: string;
    To: string;
    Region: string;
    Type: number;
    readonly Reader: string;

    constructor();
    constructor(obj: iPurchaseOrderRankFilter);	
    constructor(obj?: iPurchaseOrderRankFilter) { 
        this.From = moment(obj?.From ?? addDays(new Date(), -7)).format();
        this.To = moment(obj?.To ?? new Date()).format();
        this.Region = obj?.Region ?? "ALL";
        this.Type = obj?.Type ?? 0;
        this.Reader = getAuthData()?.userName ?? "";    
    }
}

export interface iPurchaseOrderAnalysisFilter {
    DateType: number;
    From: string;
    To: string;
    Region: string;
    ShipmentType: number;
    ReportType: number;
    ExRateUsd: number;
    ExRateHkd: number;
    ExRateRmb: number;
    ExRateThb: number;
    readonly Reader: string;
}

export class PurchaseOrderAnalysisFilter {
    DateType: number;
    From: string;
    To: string;
    Region: string;
    ShipmentType: number;
    ReportType: number;
    ExRateUsd: number;
    ExRateHkd: number;
    ExRateRmb: number;
    ExRateThb: number;
    readonly Reader: string;

    constructor();
    constructor(obj: iPurchaseOrderAnalysisFilter);	
    constructor(obj?: iPurchaseOrderAnalysisFilter) { 
        this.DateType = obj?.DateType ?? 0;
        this.From = moment(obj?.From ?? addDays(new Date(), -7)).format();
        this.To = moment(obj?.To ?? new Date()).format();
        this.Region = obj?.Region ?? "ALL";
        this.ShipmentType = obj?.ShipmentType ?? 0;
        this.ReportType = obj?.ReportType ?? 0;
        this.ExRateUsd = obj?.ExRateUsd ?? 90;
        this.ExRateHkd = obj?.ExRateHkd ?? 11.5;
        this.ExRateRmb = obj?.ExRateRmb ?? 10;
        this.ExRateThb = obj?.ExRateThb ?? 10;
        this.Reader = getAuthData()?.userName ?? "";    
    }
}

export interface iPurchaseOrderSalesSummaryFilter {
    DateType: number;
    From: string;
    To: string;
    Region: string;
    StaffId: number;
    readonly Reader: string;
}

export class PurchaseOrderSalesSummaryFilter {
    DateType: number;
    From: string;
    To: string;
    Region: string;
    StaffId: number;
    readonly Reader: string;

    constructor();
    constructor(obj: iPurchaseOrderSalesSummaryFilter);	
    constructor(obj?: iPurchaseOrderSalesSummaryFilter) { 
        this.DateType = obj?.DateType ?? 0;
        this.From = moment(obj?.From ?? addDays(new Date(), -7)).format();
        this.To = moment(obj?.To ?? new Date()).format();
        this.Region = obj?.Region ?? "ALL";
        this.StaffId = obj?.StaffId ?? 0;
        this.Reader = getAuthData()?.userName ?? "";    
    }
}